export default "__VITE_ASSET__ecff1035__"